import { cardListStyles as styles } from "@insite/content-library/Components/CardList";

styles.gridContainer = {
    gap: 0,
};
